// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

export { default as Alert } from './alert';
export { default as Avatar } from './avatar';
export { default as Badge } from './badge';
export { default as Breadcrumb } from './breadcrumb';
export { default as Button } from './button';
export { default as Card } from './card';
export { default as CardGroup } from './card-group';
export { default as Carousel } from './carousel';
export { default as Cascader } from './cascader';
export { default as Checkbox } from './checkbox';
export { default as Collapse } from './collapse';
export { default as DatePicker } from './date-picker';
export { default as Descriptions } from './descriptions';
export { default as Divider } from './divider';
export { default as Drawer } from './drawer';
export { default as Dropdown } from './dropdown';
export { default as EditableArea } from './editable-area';
export { default as Empty } from './empty';
export { default as Form } from './form';
export { default as Gap } from './gap';
export { default as Grid } from './grid';
export { default as Icon } from './icon';
export { default as Image } from './image';
export { default as Input } from './input';
export { default as Link } from './link';
export { default as List } from './list';
export { default as Menu } from './menu';
export { default as Message } from './message';
export { default as Modal } from './modal';
export { default as Pagination } from './pagination';
export { default as Popover } from './popover';
export { default as Progress } from './progress';
export { default as Radio } from './radio';
export { default as Rate } from './rate';
export { default as Rule } from './rule';
export { default as Select } from './select';
export { default as Skeleton } from './skeleton';
export { default as Slider } from './slider';
export { default as Spin } from './spin';
export { default as Steps } from './steps';
export { default as Sticky } from './sticky';
export { default as Switch } from './switch';
export { default as Table } from './table';
export { default as Tabs } from './tabs';
export { default as Tag } from './tag';
export { default as Textarea } from './textarea';
export { default as Tooltip } from './tooltip';
export { default as Transfer } from './transfer';
export { default as Tree } from './tree';
export { default as TreeSelect } from './tree-select';
export { default as Upload } from './upload';

export { setConfig, config, setLocale, setIcons, icons } from '@sheinx/base';
export type { ConfigOption } from '@sheinx/base';
export { setToken, useToken } from '@sheinx/theme';
export {
  JssProvider,
  SheetsRegistry,
  setJssConfig,
  scopeNormalizeStyle,
} from '@sheinx/shineout-style';
export * as utils from './utils';
export * from './deprecated';

export * as TYPE from './type';

export default { version: '3.9.10' };
